import { useMemo } from 'react'
import { useAppSelector } from '../../store/hooks'
import { selectAccountId, selectAuthenticatedUser } from '../../store/auth/authSlice'
import { ExternalUserServiceIntegration } from '../../models/User'
import { useGetUserIntegrationInfoQuery } from '../../store/user/user'
import { Tooltip } from '../Tooltip/Tooltip'

export const IntegrationState: React.FC<{ currentIntegration?: ExternalUserServiceIntegration; className?: string }> = ({ currentIntegration, className }) => {
  const integrationState: string | undefined = useMemo(() => {
    return currentIntegration?.state
  }, [currentIntegration])
  const integrationId: string | undefined = useMemo(() => {
    return currentIntegration?.id
  }, [currentIntegration])
  const accountId = useAppSelector(selectAccountId)
  const currentUser = useAppSelector(selectAuthenticatedUser)

  const { data: userIntegrationInfoData, isLoading: userIntegrationInfoIsLoading } = useGetUserIntegrationInfoQuery(
    {
      accountId: accountId,
      userId: currentUser?.id ?? '',
    },
    { skip: !currentUser?.id },
  )
  if (!integrationState || !integrationId || !currentUser || !currentIntegration) {
    return null
  }
  if (userIntegrationInfoIsLoading) {
    return null
  }
  if (integrationState === 'live') {
    return (
      <div className={`zocks-text-success ${className}`}>
        <i className='bi bi-check fs-5' />
        <span>Connected</span>
      </div>
    )
  }
  const integrationProblems = userIntegrationInfoData?.data.problems.filter((issue) => issue.integrationId === integrationId) ?? []
  return (
    <div className={`${className} zocks-text-danger`}>
      <i className='bi bi-exclamation fs-5' />
      {integrationProblems.length > 0 ? (
        <Tooltip id='integration-info-tooltip' className='integration-info-tooltip integration-state'>
          {integrationProblems.map((problem) => {
            return (
              <div key={problem.issue}>
                <b>{problem.issue}</b>
                <br />
              </div>
            )
          })}
        </Tooltip>
      ) : (
        <span>Your integration is invalid. Please reconnect.</span>
      )}
    </div>
  )
}
